export class EpbtFaReturnParametersModel {
    constructor(response: any) {
        this.success = response['i4go_response'] == 'SUCCESS' ? true : false;
        this.responseCode = response['i4go_responsecode'];
        this.cardType = response['i4go_cardtype'];
        this.uniqueId = response['i4go_uniqueid'];
        this.response = response['i4go_response'];
        this.responseText = response['i4go_responsetext'];
        this.maskedCard = response['i4go_maskedcard'];
        this.expirationMonth = response['i4go_expirationmonth'];
        this.expirationYear = response['i4go_expirationyear'];

        // this.useAVS = response['i4go_response'];
        // this.avsCardholdeName = response['i4go_response'];
        // this.avsStreetAddress = response['i4go_response'];
        // this.avsPostalCode = response['i4go_response'];
    }

    public success: boolean;
    public responseCode: number;
    public cardType: string;
    public uniqueId: string;
    public response: string;
    public responseText: string;
    public maskedCard: string;
    public expirationMonth: string;
    public expirationYear: string;
    public useAVS: boolean;
    public avsCardholdeName: string;
    public avsStreetAddress: string;
    public avsPostalCode: string;
}
